import z from "zod";

export const getProtocolsQuerySchema = z.object({
	projectId: z.uuid().optional(),
});

export type GetProtocolsQuery = z.infer<typeof getProtocolsQuerySchema>;
